import { render } from "./List.vue?vue&type=template&id=62f356f2&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=62f356f2&lang=scss&scoped=true"

import exportComponent from "/Users/matteomelillo/Dev/vueApps/ronchipiero.it/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f356f2"]])

export default __exports__